// TODO: Remove from `core-js@4`
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators
defineWellKnownSymbol('metadata');



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/node_modules/core-js-pure/modules/esnext.symbol.metadata.js
// module id = tX72
// module chunks = 0